import "aos/dist/aos.css";
import { useEffect, useState, useRef } from "react";
import Header from "./dashboard/header";
import getContract from "../services/contract";
import { ethers } from "ethers";
import { FaRocket } from "react-icons/fa";
import { IoMdSwap } from "react-icons/io";
import { FaMoneyCheckDollar } from "react-icons/fa6";
import { FaClipboardList } from "react-icons/fa";
import { FaFlagCheckered } from "react-icons/fa";
import { MdGeneratingTokens } from "react-icons/md";
import { FaUserLock } from "react-icons/fa";
import { FaUsers } from "react-icons/fa";
import Footer from "./footer";
import AOS from "aos";
import { TransactionService } from '../services/transactionService'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import getWallet, { connectWallet, disconnectWallet, isWalletConnected, getCurrentAddress } from '../services/wallet';
import getTokenContract from '../services/tokenContract';
import { useNavigate, useLocation } from "react-router-dom";
import queryString from 'query-string';
import {
  AiFillAccountBook,
  AiFillCopy,
  AiOutlinePaperClip,
  AiOutlineShareAlt,
} from "react-icons/ai";

const Home = (props) => {
  const navigate = useNavigate();
  const location = useLocation(); 

  const isFirstRender = useRef(true);

  let [signer, setSigner] = useState(null);
  let [loginId, setLoginId] = useState('');
  let [referrerId, setReferrerId] = useState(1);
  let [isConnected, setIsConnected] = useState(false);
  let [isConnecting, setIsConnecting] = useState(false);
  let [balance, setBalance] = useState(0);
  let [userAddress, setUserAddress] = useState('');
  let [usdtAddress, setUsdtAddress] = useState('');
  let [totalValue, setTotalValue] = useState(0);
  let [totalMembers, setTotalMembers] = useState(0);
  let [networkError, setNetworkError] = useState(null);

  const [activeIndex, setActiveIndex] = useState(null);

  const notify = (message) => toast(message);

  const handleConnectWallet = async () => {
    await connectWalletHandler();
  };

  const handleDisconnect = async () => {
    setBalance(0);
    setSigner(null);
    setUserAddress('');
    setIsConnected(false);
    disconnectWallet();
  }
  
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  // Check existing connection on mount
  useEffect(() => {
    const checkConnection = async () => {
      const connected = await isWalletConnected();
      if (connected) {
        await connectWalletHandler();
      }
    };
    checkConnection();
  }, []);

  useEffect(() => {
    AOS.init({ duration: 1500 });
    async function getData() {
      try {
        const contract = await getContract();
        const lastIdCount = await contract.lastIDCount()
        setTotalMembers(
          ethers.BigNumber.from(lastIdCount).toNumber()
        );
        
        const valueInvestedBN = await contract.totalValueInvested();
        
        const totalInvested = +ethers.utils.formatUnits(
          valueInvestedBN
        );
        
        setTotalValue(totalInvested);
        
        const token = await getTokenContract();
        setUsdtAddress(token.address);
        
      } catch (error) {
        console.log(error);
      }
    }
    getData();
  }, []);

  useEffect(() => {
    if (location.search) {
        const { refid } = queryString.parse(location.search);
        console.log(refid);
        
        if (refid) {
            setReferrerId(refid);
        }
    }
  }, [location.search])

  useEffect(() => {
    if(!signer) return
    getBalance();
  }, [signer, userAddress]);

  const addToMetamask = async () => {
    try {
      const wasAdded = await window.ethereum.request({
        method: 'wallet_watchAsset',
        params: {
          type: 'ERC20',
          options: {
            address: usdtAddress,
            symbol: 'USDT',
            decimals: 18,
          },
        },
      });

      if (wasAdded) {
        toast.success('USDT added to wallet!');
      } else {
        console.log('Your loss!');
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to add USDT");
    }
  }

  const connectWalletHandler = async () => {
    if (isConnecting) return;
    
    setIsConnecting(true);
    setNetworkError(null);
    
    try {
      const wallet = await connectWallet();
      
      if (wallet.isWrongNetwork) {
        setNetworkError("Please switch to BSC Mainnet");
        setIsConnecting(false);
        return;
      }
      
      setUserAddress(wallet.address);
      setSigner(wallet.signer);
      setIsConnected(true);
      
      toast.success(`Wallet connected: ${wallet.address.slice(0, 6)}...${wallet.address.slice(-4)}`);
      
    } catch (error) {
      console.error("Connection error:", error);
      
      if (error.message.includes("User rejected")) {
        toast.error("Please approve wallet connection");
      } else if (error.message.includes("BSC Mainnet")) {
        setNetworkError("Please switch to BSC Mainnet to continue");
      } else {
        toast.error(error.message || "Failed to connect wallet");
      }
      
      setIsConnected(false);
      setUserAddress('');
      setSigner(null);
    } finally {
      setIsConnecting(false);
    }
  }

  const getBalance = async () => {
    if (!userAddress) return;
    
    try {
      const token = await getTokenContract();
      const balance = await token.balanceOf(userAddress);
      if(balance.gt(ethers.BigNumber.from("0"))) {
        const totalBalanceBN = balance.div(ethers.BigNumber.from("1000000000000000000"));
        const totalBalance = ethers.BigNumber.from(totalBalanceBN).toString();
        setBalance(totalBalance);
      } else {
        setBalance(0);
      }
    } catch (error) {
      console.error("Error fetching balance:", error);
      setBalance(0);
    }
  }

  const handleRegister = async () => {
    if (!isConnected) {
      toast.warning("Please connect your wallet first");
      return;
    }
    
    if (networkError) {
      toast.error("Please fix network issues before registering");
      return;
    }
    
    try {
      var transactionService = new TransactionService(0, userAddress);
      const registrationPromise = transactionService.register(referrerId);
      const newId = await toast.promise(
        registrationPromise,
        {
          pending: `Registering under ID: ${referrerId}`,
          success: 'Registration Successful! 🎉',
          error: 'Registration failed'
        },
        {
          position: toast.POSITION.BOTTOM_CENTER 
        }
      )
      console.log(newId);
      
     if (newId > 0) { 
  window.location.href = '/dashboard/' + newId;
}
    } catch (error) {
      console.log(error);
      
      if (error.message.includes("user rejected")) {
        toast.error("Transaction was rejected");
      } else if (error.message.includes("insufficient funds")) {
        toast.error("Insufficient USDT balance");
      } else {
        toast.error(error.message || "Registration failed");
      }
    }
  } 

  const handleViewClick = async () => {
    if (!loginId) {
      toast.warning("Please enter an ID");
      return;
    }
    
    try {
      const contract = await getContract();
      const id = loginId;
      const lastId = ethers.BigNumber.from(
        await contract.lastIDCount()
      ).toNumber();
      if (lastId < id || id < 1) {
        toast.error(`User Id ${id} not found`);
        return;
      }
      window.location.href = "/dashboard/" + id;
    } catch (error) {
      console.error("Error checking ID:", error);
      toast.error("Error verifying user ID");
    }
  }

  const handleLogin = async () => {
    if (!isConnected) {
      toast.warning("Please connect your wallet first");
      return;
    }
    
    try {
      const contract = await getContract();
      const id = ethers.BigNumber.from(
        await contract.getIdByAddress(userAddress)
      ).toNumber();
      if (id == 0) {
        toast.error("No account found for this wallet. Please register first.");
        return;
      }
      window.location.href = "/dashboard/" + id;
    } catch (error) {
      console.error("Login error:", error);
      toast.error("Error logging in");
    }
  };

  const accordions = [
    {
      id: 0,
      title: "What is Vmines Network?",
      body: "It is a platform of Decentralized Network which is developed on Binance Blockchain (PoS). It is a smart contracts that are easily accessible for everybody, can't be changed, Vmines Network is the most powerful, highly secure and transparent distributed finance application",
    },
    {
      id: 1,
      title: "What is Plan?",
      body: "Funds Distribution compose of, Matrix 3 Levels Bonus 80%, 10%, 10%, respectively, 0% for direct sponsor. Documents can see at Dashboard, you can download.",
    },
    
    {
      id: 2,
      title: "Where to learn more?",
      body: "Please follow our official channel or social network that provide link at the footer of homepage",
    },
   {
      id: 3,
      title: "What is Vmines Token?",
      body: "It is Token of platform that will be distributed to all registered wallets, equal to amount of registration by USDT, and will be ale to trade on most popular DEX in the near future.",
   },
  ];

  return (
    <div id="home">
      <ToastContainer
        position="bottom-center"
        theme="colored"
        autoClose={5000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        style={{ zIndex: 9999 }}
      />

      <Header
        isHome={true}
        userAddress={userAddress}
        signer={signer}
        onConnectWallet={handleConnectWallet}
        onDisconnect={handleDisconnect}
        isConnecting={isConnecting}
      />

      {/* Network error banner */}
      {networkError && (
        <div className="network-error-banner" style={{
          background: '#ff4444',
          color: 'white',
          padding: '10px',
          textAlign: 'center',
          position: 'sticky',
          top: '70px',
          zIndex: 1000,
          borderRadius: '5px',
          margin: '10px'
        }}>
          ⚠️ {networkError}
          <button 
            onClick={connectWalletHandler}
            style={{ 
              marginLeft: '10px', 
              padding: '5px 15px', 
              cursor: 'pointer',
              background: 'white',
              color: '#ff4444',
              border: 'none',
              borderRadius: '5px',
              fontWeight: 'bold'
            }}
          >
            Try Again
          </button>
        </div>
      )}

      <section
        className="banner"
        style={{ backgroundImage: "url(/logo/bg3.jpg)" }}
      >
        <div className="banner-sections">
          <div className="logo-sec" data-aos="fade-right">
            <img
              src="/logo/logo.png"
              style={{ width: "500px", margin: "0 auto" }}
              alt="Logo"
            />
          </div>
        </div>
      </section>
      
      <section className="custom-container authentication-section">
      {/*  <div className="login" data-aos="fade-right">
          <h3>Login to view</h3>
          <input 
            onChange={(e) => setLoginId(e.target.value)} 
            value={loginId} 
            id="idbyPlan" 
            type="number" 
            placeholder="Enter Id" 
          />
          <div className="actions">
            <button onClick={handleViewClick} className="button lightBtn">Search</button>
            <button 
              onClick={handleLogin} 
              className="button primaryBtn"
              disabled={!isConnected}
            >
              Login
            </button>
          </div>
          {!isConnected && (
            <p style={{ fontSize: '12px', marginTop: '10px', color: '#666' }}>
              Connect wallet to login
            </p>
          )}
        </div> */}

        <div className="login" data-aos="fade-right">
  <h3>Login to view</h3>
  <input 
    onChange={(e) => setLoginId(e.target.value)} 
    value={loginId} 
    id="idbyPlan" 
    type="number" 
    placeholder="Enter Id" 
    style={{ width: '100%', boxSizing: 'border-box' }}
  />
  <div className="actions" style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
    <button 
      onClick={handleViewClick} 
      className="button lightBtn"
      style={{ flex: 1, textAlign: 'center' }}
    >
      Search
    </button>
    <button 
      onClick={handleLogin} 
      className="button primaryBtn"
      disabled={!isConnected}
      style={{ flex: 1, textAlign: 'center' }}
    >
      Login
    </button>
  </div>
  {!isConnected && (
    <p style={{ fontSize: '12px', marginTop: '10px', color: '#666' }}>
      Connect wallet to login
    </p>
  )}
</div>
        
        <div className="register" data-aos="fade-left">
          <div className="register-form">
            <h3>Join under ID</h3>
            <input 
              onChange={(e) => setReferrerId(e.target.value)} 
              value={referrerId} 
              id="idbyPlan" 
              type="number" 
              placeholder="Enter Upline Id" 
            />
          <div className="requireAmount">
  <i className="las la-info-circle text-3xl text-base"></i>
  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
    <span>Start with 5 USDT</span>
    <span>Balance : {balance}</span>
  </div>
</div>

<div className="register-form">


{/* <div className="actions">
  <button 
    onClick={handleRegister} 
    className="button lightBtn"
    disabled={isConnecting || !isConnected}
    style={{     
      background: "linear-gradient(45deg, #fb1df0, #0044ff, #00ff33, #FFD700)",
      backgroundSize: '200% 200%',
      animation: "gradientShift 2s ease infinite",
      border: 'none',
      color: 'black',
      fontWeight: 'bold',
      position: 'relative',
      overflow: 'hidden',
      transition: 'transform 0.3s ease',

        whiteSpace: "nowrap",
                          height: "70px",
                          fontSize: "clamp(18px, 2vw, 26px)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "100%",
                          padding: "0 30px",
                          border: "none",
                          borderRadius: "15px",
                          color: "#fff",
                          textShadow: "0 2px 4px rgba(0,0,0,0.3)",
                          transition: "transform 0.3s ease",
                          cursor: "pointer",
                          boxSizing: "border-box",
                          fontWeight: "bold",
                          boxShadow: "0 10px 25px rgba(0,0,0,0.5)",
                          letterSpacing: "1px"
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'scale(1.05)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'scale(1)';
    }}
  >
    {isConnecting ? 'Connecting...' : 'REGISTER'}
  </button> 

</div>

<style>
  {`
    @keyframes shimmer {
      0% {
        background-position: 0% 0%;
      }
      50% {
        background-position: 100% 100%;
      }
      100% {
        background-position: 0% 0%;
      }
    }
  `}
</style> */}

<div className="actions">
  <button 
    onClick={handleRegister} 
    className="button lightBtn"
    disabled={isConnecting || !isConnected}
    style={{     
      background: "linear-gradient(90deg, #fb1df0, #00bfff, #00ff33, #FFD700, #f80c14)",
      backgroundSize: '400% 100%',
      animation: "gradientShift 8s ease infinite",
      border: 'none',
      color: 'white',
      fontWeight: 'bold',
      position: 'relative',
      overflow: 'hidden',
      whiteSpace: "nowrap",
      height: "70px",
      fontSize: "clamp(18px, 2vw, 26px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      padding: "0 30px",
      borderRadius: "15px",
      textShadow: "0 2px 4px rgba(0,0,0,0.3)",
      transition: "transform 3s ease",
      cursor: "pointer",
      boxSizing: "border-box",
      boxShadow: "0 10px 25px rgba(0,0,0,0.5)",
      letterSpacing: "1px"
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'scale(1.05)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'scale(1)';
    }}
  >
    {isConnecting ? 'Connecting...' : 'REGISTER'}
  </button> 
</div>

<style>
  {`
    @keyframes gradientShift {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }
  `}
</style>

  </div>
         
             {/* <div className="actions">
              <button 
                onClick={handleRegister} 
                className="button lightBtn"
                disabled={isConnecting || !isConnected}
              >
                {isConnecting ? 'Connecting...' : 'REGISTER'}
              </button> 
              <span className="balance ml-5">USDT: {balance} </span>     
            </div>    */}   
          </div>
          <div className="info-card">
            <div className="heading">
              <h4>How to Invest</h4>
            </div>
            <p>
              Access the website via Metamask mobile app or use browser
              extension. For Mobile users use Trust wallet app or Tocken Pocket
              (TP) for choices
            </p>
            <div className="heading">
              <h4>How To Access Dashboard</h4>
            </div>
            <p>
              You'll automatically navigate to Dashboard after joining OR Access
              Your Dashboard Via Homepage Login Button
            </p>
          </div>
        </div>
      </section>
      
      <div
        className="grid grid-cols-4 dashboard-copy-grid items-center mb-5"
        style={{ gap: "10px" }}
      >
        <div className="col-span-2 grid-left text-center">
          <div
            className="grid grid-cols-2"
            style={{ gap: "10px", marginTop: "10px" }}
          >
            <div
              className="border p-5 rounded-md"
              style={{
                borderColor: "rgb(7, 197, 244)",
                background: "#ffdc50",           
              }}
            >
              <h3
                style={{
                  fontSize: "18px",
                  marginBottom: "10px",
                  fontWeight: "bold",
                  color: "black"
                }}
              >
                Total Account
              </h3>
              <div className="text-center">
                <h2 style={{ fontSize: "22px", color: "#0629f1", fontWeight: "bold"}}>{totalMembers}</h2>
              </div>
            </div>
            <div
              className="border p-5 rounded-md"
              style={{
                borderColor: "rgb(7, 197, 244)",
                background: "#ffdc50",            
              }}
            >
              <h3
                style={{
                  fontSize: "18px",
                  marginBottom: "10px",
                  fontWeight: "bold",
                  color: "black"              
                }}
              >
                Total USDT
              </h3>
              <div className="text-center">
                <h2 style={{ fontSize: "22px", color: "#0629f1", fontWeight: "bold" }}>{totalValue}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section>
        <div className="custom-container roadmap">
          <h6 className="section-heading" data-aos="fade-up">
            FAQ
          </h6>
          <span data-aos="fade-up">
            We have provided major frequently Asked Questions (FAQ) by below, strongly recommend to join our communities of social network for more detials.
          </span>
          <div className="qna" data-aos="fade-up">
            <div
              className="panel-group"
              id="accordion"
              role="tablist"
              aria-multiselectable="true"
            >
              {accordions.map((item) => (
                <div key={item.id} className="panel panel-default">
                  <div className="panel-heading" role="tab">
                    <h4 className="panel-title">
                      <a
                        className={activeIndex === item.id ? "" : "collapsed"}
                        role="button"
                        onClick={() => toggleAccordion(item.id)}
                        aria-expanded={activeIndex === item.id}
                      >
                        {item.title}
                      </a>
                    </h4>
                  </div>
                  <div
                    className={`panel-collapse collapse ${
                      activeIndex === item.id ? "show" : ""
                    }`}
                    role="tabpanel"
                  >
                    <div className="panel-body">
                      <p>{item.body}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default Home;